import { useTheme } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon as iconTokens } from '../../theme/tokens/component';

const sizeMap = {
    tiny: iconTokens.size.tiny,
    xs:   iconTokens.size.xs,
    sm:   iconTokens.size.sm,
    md:   iconTokens.size.md,
    lg:   iconTokens.size.lg,
    xl:   iconTokens.size.xl,
    huge: iconTokens.size.huge,
};

const Icon = ({ icon, size, color, style, ...props }) => {
    const theme = useTheme();
    const resolvedColor = color && typeof color === 'string'
        ? (() => {
            if (/^(#|rgb|hsl|var\()/.test(color)) return color;
            const [key, shade] = color.split('.');
            if (shade) return theme.palette[key]?.[shade];
            return theme.palette[key]?.main ?? theme.palette[key];
        })()
        : undefined;

    return (
        <FontAwesomeIcon
            icon={icon}
            style={{ fontSize: sizeMap[size], color: resolvedColor, ...style }}
            {...props}
        />
    );
};

export default Icon;